import React, { useEffect, useState } from "react";
import { useRef } from "react";
import {
  FormGroup,
  FormControlLabel,
  Checkbox, Typography,
  InputAdornment,
  Autocomplete
} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import axiosInstance from "../../../../lib/axios";
import axios from "../../../../lib/axios";
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from '@mui/icons-material/Search';
import CustomAutoCompleteNew from "../../../AutoComplete/CustomAutoCompleteNew";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";

const columns = [
  { id: "RowNum", label: "Sr.No.", minWidth: 5 },
  { id: 'Name', label: 'AuthorityName', minWidth: 10 },
  { id: 'MobileNo', label: 'MobileNo', minWidth: 50 },
  { id: 'Email', label: 'Email', minWidth: 50 },
  { id: 'DesiId', label: 'Designation', minWidth: 50 }
];

const CouponAuthority = () => {
  const [formData, setFormData] = useState({
    Name: "",
    MobileNo: "",
    Email: "",
    DesiId: "",
  });

  const [error, setError] = useState({
    Name: false,
    MobileNo: false,
    Email: false,
  });

  const navigate = useNavigate();
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [UserId] = useState(sessionStorage.getItem("UserId"));
  const location = useLocation();
  const [currentAuthId, setCurrentAuthId] = useState(null);
  const [jobTitle, setJobTitle] = useState([]);
  const [mode, setMode] = useState("view");
  const [lastInsertedAuthId, setLastInsertedAuthId] = useState(null);
  const [Status, setStatus] = useState("1");
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });
  const [isRefreshing, setIsRefreshing] = useState(false);

  const NameRef = useRef(null);
  const MobileNoRef = useRef(null);
  const EmailRef = useRef(null);
  const DesignationRef = useRef(null);

  const openDesgTab = () => {
    window.open("/designation");
  };

  const handleRefreshDesg = async () => {
    setIsRefreshing(true);
    try {
      const response = await axiosInstance.post(`MstDesi/getMstDesidrp`);
      const { data: { Status, Data } } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setJobTitle(Data);
      } else {
        setJobTitle([]);
      }
    } catch (error) {
      console.error("Error refreshing job titles:", error)
    } finally {
      setTimeout(() => {
        setIsRefreshing(false);
      }, 300);
    }
  };

  useEffect(() => {
    if (location.state && location.state.AuthId) {
      setCurrentAuthId(location.state.AuthId);
      fetchCouponAuthorityData(location.state.AuthId);
      setMode("view");
    } else {
      setMode("add");
      setIsFormDisabled(false);
    }
  }, [location]);

  const fetchCouponAuthorityData = async (id, flag) => {
    try {
      const response = await axiosInstance.post(
        "MstPromoCodeAuth/RetriveMstPromoCodeAuth",
        {
          AuthId: parseInt(id),
          Flag: flag,
        }
      );

      if (
        response.data.Status === 0 &&
        response.data.responseStatusCode === 1
      ) {
        const AuthorityData = response.data.Data[0];

        setFormData({
          UserId: AuthorityData.UserId,
          Name: AuthorityData.Name,
          MobileNo: AuthorityData.MobileNo,
          Email: AuthorityData.Email || "",
          DesiId: AuthorityData.DesiId || "",
        });
        setStatus(AuthorityData.Status?.toString() || "0");
        setIsFormDisabled(true);
        setCurrentAuthId(AuthorityData.AuthId);
      } else if (
        response.data.Status === 1 &&
        response.data.responseStatusCode === 2
      ) {
        console.error(response.data.Message, { autoClose: 1000 });
      } else {
        console.error("Failed to fetch coupon authority data", {
          autoClose: 1000,
        });
      }
    } catch (error) {
      console.error("Error fetching coupon authority data:", error);
     
    }
  };

  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: ""
      };

      try {
        const res = await axios.post('MstPromoCodeAuth/GetAllMstPromoCodeAuthDashBoard', { params });

        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    getRow();
  }, []);

  useEffect(() => {
    const getJobTitle = async () => {
      try {
        const response = await axiosInstance.post(`MstDesi/getMstDesidrp`);
        if (response.data && response.data.Data) {
          setJobTitle(response.data.Data);
        } else {
          setJobTitle([])
        }
      } catch (err) {
        console.error("Error fetching courses:", err);
      }
    };
    getJobTitle();
  }, []);

  const handlePrevious = async () => {
    if (currentAuthId && currentAuthId > 1) {
      await fetchCouponAuthorityData(currentAuthId, "P");
    }
  };

  const handleNext = async () => {
    if (currentAuthId) {
      await fetchCouponAuthorityData(currentAuthId, "N");
    }
  };



  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log(`Updating form field: ${name} with value: ${value}`);
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      if (event.target === NameRef.current) {
        MobileNoRef.current.focus();
      } else if (event.target === MobileNoRef.current) {
        EmailRef.current.focus();
      } else if (event.target === EmailRef.current) {
        DesignationRef.current.focus();
      } else {
        DesignationRef.current.focus();
      }
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  const handleSave = async () => {
    let hasError = false;

    if (!formData.Name) {
      toast.error('Authority Name is required', { autoClose: 1000 });
      setError(prev => ({ ...prev, Name: true }));
      hasError = true;
    } else {
      setError(prev => ({ ...prev, Name: false }));
    }

    if (!formData.MobileNo || !/^\d{10}$/.test(formData.MobileNo)) {
      toast.error(formData.MobileNo ? 'MobileNo must be 10 digits' : 'MobileNo is required', { autoClose: 1000 });
      setError(prev => ({ ...prev, MobileNo: true }));
      hasError = true;
    } else {
      setError(prev => ({ ...prev, MobileNo: false }));
    }

    if (!formData.Email || !/\S+@\S+\.\S+/.test(formData.Email)) {
      toast.error(formData.Email ? 'Email is not valid' : 'Email is required', { autoClose: 1000 });
      setError(prev => ({ ...prev, Email: true }));
      hasError = true;
    } else {
      setError(prev => ({ ...prev, Email: false }));
    }

    if (hasError) {
      return;
    }

    try {
      const payload = {
        UserId: parseInt(UserId),
        Name: formData.Name,
        MobileNo: formData.MobileNo,
        Email: formData.Email,
        DesiId: parseInt(formData.DesiId),
        Status: Status,
      };

      let response;
      if (mode === "edit") {
        payload.AuthId = currentAuthId;
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axiosInstance.patch(
          "MstPromoCodeAuth/UpdateMstPromoCodeAuth",
          payload
        );
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axiosInstance.post(
          "MstPromoCodeAuth/InsertMstPromoCodeAuth",
          payload
        );
      }

      if (
        response.data.Status === 0 &&
        response.data.responseStatusCode === 1
      ) {
        toast.success(response.data.Message, { autoClose: 1000 });
        if (mode === "add") {
          setLastInsertedAuthId(response.data.Data);
          // await fetchCouponAuthorityData(response.data.Data);
          setMode("view");
          setIsFormDisabled(true);
          setCurrentAuthId(response.data.Data);
        } else {
          setMode("view");
        }
        setIsFormDisabled(true);
        // resetForm();
      } else {
        console.error(response.data.Message || "Operation failed");
      }
    } catch (error) {
      console.error("Error saving/updating coupon authority:", error);
    }
  };

  const handleEdit = () => {
    setMode("edit");
    setIsFormDisabled(false);
  };

  const handleAdd = () => {
    setMode("add");
    setIsFormDisabled(false);
    setFormData({
      Name: "",
      MobileNo: "",
      Email: "",
      DesiId: "",
    });
    setStatus("1");
    setCurrentAuthId(null);

    setTimeout(() => {
      NameRef.current.focus();
    }, 0);
  };

  const handleCancel = async () => {
    try {
      await fetchCouponAuthorityData(1, "L");
      setMode("view");
      setIsFormDisabled(true);
    } catch (error) {
      console.error("Error occurred while cancelling. Please try again.",error);
    }
  };

  const resetForm = () => {
    setFormData({
      Name: "",
      MobileNo: "",
      Email: "",
      DesiId: ""
    });
    setCurrentAuthId(null);
    setMode("view");
    setStatus(0);
  };

  const handleExit = () => {
    navigate("/couponAuthorityTable");
  };

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    // try {
    //   await fetchCouponAuthorityData(currentAuthId, "D");
    //   await fetchCouponAuthorityData(currentAuthId, "N");
    //   setMode("view");
    //   setIsFormDisabled(true);
    // } catch (error) {
    //   console.error("Error deleting zone:", error);
    //   toast.error("Error occurred while deleting. Please try again.", {
    //     autoClose: 1000,
    //   });
    // }
    try {
      const response = await axiosInstance.post(
        "MstPromoCodeAuth/RetriveMstPromoCodeAuth",
        {
          AuthId: currentAuthId,
          Flag: 'D',
        }
      );

      if (
        response.data.Status === 0 &&
        response.data.responseStatusCode === 1
      ) {
        if (response instanceof Error) {
          return console.error("Error: could not delete coupon");
        }
        const {
          data: { Status, Message, Data },
        } = response;
        if (Status === 0) {
          toast.success(Message, { autoClose: 1000 });
          await fetchCouponAuthorityData(currentAuthId, "N");
        } else {
          if (Array.isArray(Data) && Data.length > 0) {
            const msg = formatDeleteErrorMessage(Data);
            toast.error(msg, { autoClose: 1000 });
          } else {
            toast.error(Message, { autoClose: 1000 });
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const spinAnimation = {
    animation: isRefreshing ? 'spin 1s linear infinite' : 'none',
  };

  return (
    <>
      <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
        <ToastContainer />
        <Grid container spacing={2} className="form_grid">
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              flexDirection: { xs: 'column', sm: 'row', md: 'row' }
            }}
          >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                marginBottom: { xs: '10px', sm: 0 }
              }}
            >
              <Button
                variant="contained"
                size="small"
                className="three-d-button-previous"
                onClick={handlePrevious}
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                disabled={
                  mode !== "view" || !currentAuthId || currentAuthId === 1
                }
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                className="three-d-button-next"
                onClick={handleNext}
                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== "view" || !currentAuthId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              Coupon Authority
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Coupon Authority"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleDeleteClick}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field" sx={{ marginInline: '50px', marginTop: '30px' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="Name"
                  name="Name"
                  label={
                    <span>
                      AuthorityName<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  disabled={isFormDisabled}
                  value={formData.Name}
                  onChange={handleInputChange}
                  error={error.Name}
                  helperText={error.Name && ""}
                  inputRef={NameRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="MobileNo"
                  name="MobileNo"
                  label={
                    <span>
                      MobileNo<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  disabled={isFormDisabled}
                  value={formData.MobileNo}
                  onChange={handleInputChange}
                  error={error.MobileNo}
                  helperText={error.MobileNo && ""}
                  inputRef={MobileNoRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                <TextField
                  id="Email"
                  name="Email"
                  label={
                    <span>
                      Email<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  disabled={isFormDisabled}
                  value={formData.Email}
                  onChange={handleInputChange}
                  error={error.Email}
                  helperText={error.Email && ""}
                  inputRef={EmailRef}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field" sx={{ marginInline: '50px' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={4}>
                <CustomAutoCompleteNew
                  id="DesiId-select"
                  name="DesiId"
                  options={jobTitle}
                  value={jobTitle.find((title) => title.Id === formData.DesiId) || ''}
                  onChange={handleInputChange}
                  label={
                    <span>
                      Designation <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  disabled={isFormDisabled}
                  onAddClick={openDesgTab}
                  onRefreshClick={handleRefreshDesg}
                  isRefreshing={isRefreshing}
                  inputRef={DesignationRef}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isFormDisabled}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === "view" && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                  }}
                  onClick={handleAdd}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                  }}
                  onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === "edit" || mode === "add") && (
              <>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{ mr: 1 }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {rows.length > 0 && <ReportTable
          columns={columns}
          rows={rows}
          title="Coupon Authority"
          contentRef={contentRef}
          customStyles={{ backgroundColor: '#f5f5f5' }}
        />
        }
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CouponAuthority;

